import * as React from "react";
import { connect } from "react-redux";
import Signup from "../../screens/Signup";
import { fetchCountry, signup } from "./action";

function SignupContainer(props) {
  return (
    <Signup
      fetchCountry={props.fetchCountry}
      countryList={props.countryList}
      signup={props.signup}
      countryprofdetailList={props.countryprofdetailList}
    />
  );
}

function bindAction(dispatch) {
  return {
    fetchCountry: () => {
      dispatch(fetchCountry());
    },
    signup: (value) => {
      dispatch(signup(value));
    },
  };
}

function mapStateToProps(state) {
  return {
    countryList: state.SignupReducer.countryList,
    countryprofdetailList: state.SignupReducer.countryprofdetailList,
  };
}

export default connect(mapStateToProps, bindAction)(SignupContainer);
